export const numberValue = (value: string) => (!isNaN(Number(value)) ? Number(value) : 0);
